import * as yup from 'yup';

const CommercialInformationModel = () => {
  const initialValues = {
    type: "",
    is_pre_inscription: false,
    state: "Closed",
    name: "",
    description: "",
    initialDate: null,      // Date | null
    endDate: null,          // Date | null
    initBreak: null,        // Date | null
    endBreak: null,         // Date | null
    closeCampusDate: null,  // Date | null
    classQuantity: 1,
    image: "", //URL
    classDays: "", //Ej: Lunes y Jueves [String]
    classHour: "", //Ej: 19:00 [String]
  }

  const validationSchema = yup.object().shape({
    is_pre_inscription: yup.boolean(),

    type: yup.string().required("El tipo es obligatorio"),
    name: yup.string().required("El nombre es obligatorio"),
    description: yup.string().required("La descripción es obligatoria"),
    image: yup.string().url("La imagen debe ser una URL válida").required("La imagen es obligatoria"),

    initialDate: yup.date().when('is_pre_inscription', {
      is: false,
      then: (schema) => schema.required("La fecha inicial es obligatoria"),
      otherwise: (schema) => schema.notRequired()
    }),

    endDate: yup.date().when('is_pre_inscription', {
      is: false,
      then: (schema) => schema
        .required("La fecha final es obligatoria")
        .min(yup.ref('initialDate'), 'La fecha final debe ser posterior a la inicial'),
      otherwise: (schema) => schema.notRequired()
    }),

    classQuantity: yup.number().when('is_pre_inscription', {
      is: false,
      then: (schema) => schema.required("La cantidad de clases es obligatoria").min(1, "La cantidad mínima de clases es 1"),
      otherwise: (schema) => schema.notRequired()
    }),

    classDays: yup.string().when('is_pre_inscription', {
      is: false,
      then: (schema) => schema.required("Los días de clase son obligatorios"),
      otherwise: (schema) => schema.notRequired()
    }),

    classHour: yup.string().when('is_pre_inscription', {
      is: false,
      then: (schema) => schema
        .required("La hora de clase es obligatoria")
        .matches(
          /^(?:[01]?[0-9]|2[0-3]):([0-5]?[0-9])$/,
          "La hora debe estar en formato HH:mm (00:00 a 23:59)"
        ),
      otherwise: (schema) => schema.notRequired()
    }),

    closeCampusDate: yup.date().when('is_pre_inscription', {
      is: false,
      then: (schema) => schema.required("La fecha de cierre de campus es obligatoria"),
      otherwise: (schema) => schema.notRequired()
    }),
  });

  return { initialValues, validationSchema }
}

export { CommercialInformationModel };
